import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'account-faqs-page-nav',
  templateUrl: './account-faqs-page-nav.component.html',
  styleUrls: ['./account-faqs-page-nav.component.scss']
})
export class AccountFAQsPageNavComponent {
  @Output() private selectCategory: EventEmitter<number> = new EventEmitter<number>();
  @Input() public categories: string[] = [];
  @Input() public activeIndex = 0;

  public onSelectCategory(index: number): void {
    this.selectCategory.emit(index);
  }
}
